module.exports = __webpack_public_path__ + "media/images/flags/1x1/asm-abed88d923fbcd48b1af8ffd8256b966.svg";